export default "__VITE_ASSET__50VBsiRL__"